
const journeyTypeEnum = {
 INDIVIDUAL_AND_FAMILY:"Individual (& Family)",
 NRI:"NRI Individual",
 FOREIGN_NATIONAL:"Foreign National",
 FNIO_PIO:"FNIO/PIO",
 OTHERS:"Other"

}

export default journeyTypeEnum;
